// * Controls whether sessions are deleted by creation time or by last activity.
// * Stored DB values are kept as-is for backward compatibility.
export enum DataRetentionMode {
  SinceCreation = 'sinceCreation',
  SinceLastInput = 'sinceLastInput',
}

// * Data retention defaults to enabled — companies must explicitly opt out
export const DEFAULT_DATA_RETENTION_ENABLED = true;

export const DEFAULT_DATA_RETENTION_MODE = DataRetentionMode.SinceLastInput;

export const DEFAULT_DATA_RETENTION_THRESHOLD_TIME = '90d';

export const DATA_RETENTION_MODE_PATH = 'dataRetentionSettings.mode';

export const PSEUDONYMIZATION_SYSTEM_PROMPT = `
You are a pseudonymization assistant. You will receive a JSON array of strings.
Replace sensitive personal data (names, emails, phone numbers, addresses, etc.) with tokens like [NAME], [EMAIL], [PHONE], [ADDRESS].
Return ONLY a valid JSON array of strings with exactly the same number of elements as the input.
Non-sensitive strings must be returned unchanged.
Example input:  ["John Doe", "john@example.com", "Hello world"]
Example output: ["[NAME]", "[EMAIL]", "Hello world"]
`;
